<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    v-model="showModal"
    :title="$route.params.id ? 'اضافه کردن کاربر' : 'ایجاد کاربر'"
    hide-footer
    centered
    noCloseOnBackdrop
  >
    <validation-observer
      ref="addUsersForm"
      #default="{ invalid }"
      v-if="$route.params.id"
    >
      <b-form class="auth-add-users my-2" @submit.prevent="addUsers">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="users"
            vid="users"
            rules="required"
          >
            <select-box
              url="user"
              v-model="users"
              label="text"
              multiple
              searchable
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-button
          variant="primary"
          block
          type="submit"
          class="my-1"
          :disabled="invalid"
        >
          اضافه کردن کاربر
        </b-button>
      </b-form>
    </validation-observer>

    <validation-observer ref="addUserForm" #default="{ invalid }" v-else>
      <b-form class="auth-add-user-form my-2" @submit.prevent="addUser">
        <b-form-group label="موبایل" label-for="add-user-phone">
          <validation-provider
            #default="{ errors }"
            name="phone"
            vid="phone"
            rules="required|mobile"
          >
            <b-form-input
              autocomplete="on"
              id="add-user-phone"
              v-model="phone"
              name="add-user-phone"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <div class="d-flex justify-content-between">
          <b-form-group label="نام" class="mr-1" label-for="add-user-firstname">
            <validation-provider
              #default="{ errors }"
              name="firstname"
              vid="firstname"
              rules="required|min:4|totalPerisan"
            >
              <b-form-input
                autocomplete="on"
                id="add-user-firstname"
                v-model="firstname"
                name="add-user-firstname"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            class="ml-1"
            label="نام خانوادگی"
            label-for="add-user-lastname"
          >
            <validation-provider
              #default="{ errors }"
              name="lastname"
              vid="lastname"
              rules="required|min:4|totalPerisan"
            >
              <b-form-input
                autocomplete="on"
                id="add-user-lastname"
                v-model="lastname"
                name="add-user-lastname"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <!-- email -->
        <b-form-group label="ایمیل" label-for="add-user-email">
          <validation-provider
            #default="{ errors }"
            name="Email"
            vid="email"
            rules="required|email"
          >
            <b-form-input
              autocomplete="on"
              id="add-user-email"
              v-model="userEmail"
              name="add-user-email"
              :state="errors.length > 0 ? false : null"
              placeholder="admin@example.com"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <div class="d-flex justify-content-between">
          <b-form-group
            class="mr-1"
            label-for="add-user-password"
            label="رمز عبور"
          >
            <validation-provider
              #default="{ errors }"
              name="Password"
              vid="password"
              rules="required|min:6|notArabic"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  autocomplete="on"
                  id="add-user-password"
                  v-model="password"
                  class="form-control-merge"
                  :type="toggleConfrimPasswordVisibility ? 'password' : 'text'"
                  :state="errors.length > 0 ? false : null"
                  name="add-user-password"
                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="
                      toggleConfrimPasswordVisibility ? 'EyeIcon' : 'EyeOffIcon'
                    "
                    class="cursor-pointer"
                    @click="
                      toggleConfrimPasswordVisibility =
                        !toggleConfrimPasswordVisibility
                    "
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            class="ml-1"
            label-for="add-user-confrim-password"
            label="تایید رمز عبور"
          >
            <validation-provider
              #default="{ errors }"
              name="confrim-password"
              vid="confrim-password"
              :rules="`required|min:6|notArabic|confirmed:${password}`"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  autocomplete="on"
                  id="add-user-confrim-password"
                  v-model="confrimPassword"
                  class="form-control-merge"
                  :type="togglePasswordVisibility ? 'password' : 'text'"
                  :state="errors.length > 0 ? false : null"
                  name="add-user-confrim-password"
                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="togglePasswordVisibility ? 'EyeIcon' : 'EyeOffIcon'"
                    class="cursor-pointer"
                    @click="
                      togglePasswordVisibility = !togglePasswordVisibility
                    "
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <b-form-group label="جنسیت" label-for="edit-email" class="px-1">
          <div class="d-flex pt-50">
            <b-form-radio
              v-model="gender"
              name="gender"
              id="gender-1"
              value="0"
              class="mr-3 custom-control-primary"
            >
              مرد
            </b-form-radio>
            <b-form-radio
              v-model="gender"
              name="gender"
              id="gender-2"
              value="1"
              class="custom-control-primary"
            >
              زن
            </b-form-radio>
          </div>
        </b-form-group>
        <b-button
          variant="primary"
          block
          type="submit"
          class="my-1"
          :disabled="invalid"
        >
          ایجاد کاربر
        </b-button>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
  BFormRadio,
} from "bootstrap-vue";
import { required, mobile, notArabic } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
    BModal,
    SelectBox,
    BFormRadio,
  },
  data() {
    return {
      status: "",
      phone: "",
      lastname: "",
      firstname: "",
      userEmail: "",
      password: "",
      users: [],
      confrimPassword: "",
      gender: 0,
      loading: false,
      togglePasswordVisibility: true,
      toggleConfrimPasswordVisibility: true,
      required,
      mobile,
      notArabic,
    };
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.users = [];
      }
    },
    phone(newVal) {
      this.phone = this.p2e(newVal);
    },
  },
  methods: {
    addUser() {
      this.$refs.addUserForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("/panel/users", {
              first_name: this.firstname,
              last_name: this.lastname,
              mobile: this.phone,
              email: this.userEmail,
              password: this.password,
              password_confirmation: this.confrimPassword,
              gender: this.gender,
            });
            setTimeout(() => {
              this.$emit("updateUsers");
            }, 500);
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "کاربر با موفقیت اضافه شد.",
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
            this.users = [];
            this.showModal = false;
          } catch (err) {
            this.loading = false;
            this.showModal = false;
          }
        }
      });
    },
    addUsers() {
      this.$refs.addUsersForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            await this.users.map(async (user) => {
              await this.$http.patch(
                this.$route.path.includes("courses")
                  ? `/panel/courses/${this.$route.params.id}/students/${user.id}`
                  : `/panel/semesters/${this.$route.params.id}/students/${user.id}`
              );
            });
            setTimeout(() => {
              this.$emit("updateUsers");
            }, 500);
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "کاربر با موفقیت ایجاد شد.",
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
            this.showModal = false;
          } catch (err) {
            this.loading = false;
            this.showModal = false;
          }
        }
      });
    },
  },
};
</script>
